import styled from "styled-components";

export const SignUpButton = styled.button`
  background-color: ${(props) => (props.disabled ? "#007DFF99" : "#007DFF")};
  opacity: ${(props) => props.disabled && "0.5"};
  border-radius: 16px;
`;
